import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/es/index.js
// module id = 615
// module chunks = 3